var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_vm._v(" You will be automatically redirected. Or "),_c('router-link',{attrs:{"to":_vm.redirectPath}},[_vm._v("click here")]),_vm._v(". ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }